var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('div',{staticClass:"text-menu-container"},_vm._l((_vm.items),function(menuItem,Idx){return _c('text-menu',{key:Idx,attrs:{"menu-item":menuItem,"card-style":_vm.cardStyle},on:{"on-click":function($event){return _vm.clickHandler(menuItem)}}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }